// Generated for @nava/participant-copy: Clair's default texts in Swedish. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Swedish. Written for Clair. */
export const PARTICIPANT_COPY_SV = {
    'landing.changeLanguage': 'Byt språk',
    'common.language': 'Språk',
    'common.talkInLanguages': 'Du kan prata med Clair på fler än 80 språk.',
    'common.seeLanguages': 'Visa vilka',
    'footer.poweredBy': 'Drivs av',
    'landing.heading': 'Du har blivit inbjuden till ett kort samtal.',
    'landing.intro': '{company} vill gärna höra hur det går för dig. Du pratar med Clair, en AI-assistent, när det passar dig.',
    'landing.continue': 'Fortsätt',
    'preflight.title': 'Vi behöver bara några saker',
    'preflight.checkInSubtitle': 'Gå igenom listan nedan för att starta samtalet.',
    'preflight.actions.expandItem': 'Expandera {{item}}',
    'preflight.microphone.title': 'Mikrofonåtkomst',
    'preflight.microphone.checkInPrivacy': 'Din röst används för samtalet med Clair, en AI-assistent. Samtalet spelas in, transkriberas och delas med {company}. All data krypteras och lagras säkert.',
    'preflight.microphone.readMore': 'Läs mer',
    'preflight.microphone.grantAccess': 'Ge åtkomst',
    'preflight.microphone.indicatorAction': 'Ge mikrofonåtkomst',
    'preflight.microphone.accessGranted': 'Åtkomst beviljad',
    'preflight.microphone.errorHelper': 'Kontrollera dina webbläsarinställningar och försök igen.',
    'preflight.microphone.browserNotSupported': 'Din webbläsare stöder inte ljudinspelning. Använd Chrome, Firefox eller Safari.',
    'preflight.terms.title': 'Integritet & samtycke',
    'preflight.terms.checkInPrivacy': 'Samtalet hålls av Clair, en AI-assistent, på uppdrag av {company}. Dina svar delas med {company} och används aldrig för reklam. Du kan avbryta när du vill.',
    'preflight.terms.readMore': 'Läs mer',
    'preflight.terms.accept': 'Ja, jag accepterar',
    'preflight.terms.indicatorAction': 'Acceptera integritet och samtycke',
    'preflight.terms.accepted': 'Accepterat',
    'preflight.terms.rememberConsent': 'Kom ihåg mitt samtycke i 30 dagar',
    'preflight.terms.rememberConsentCallTooltip': 'Samtycket sparas bara för det här samtalet, i den här webbläsaren, i 30 dagar.',
    'quickStart.agree': 'Godkänn',
    'quickStart.back': 'Tillbaka',
    'quickStart.cancel': 'Avbryt',
    'preflight.startCheckIn': 'Starta samtalet',
    'preflight.preparingCheckIn': 'Förbereder samtalet...',
    'preflight.preparingCheckInDelayedTitle': 'Förbereder samtalet.',
    'preflight.preparingCheckInDelayedSubtitle': 'Jobbar fortfarande, vänta.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Det här tar längre tid än väntat.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Ha tålamod.',
    'preflight.checkInPreparationFailedTitle': 'Det gick inte att förbereda samtalet',
    'preflight.checkInPreparationFailedMessage': 'Några filer till samtalet kunde inte laddas. Kontrollera anslutningen och försök igen.',
    'preflight.retryPreparation': 'Försök igen',
    'interview.status.connecting': 'Ansluter',
    'interview.status.speaking': 'Talar',
    'interview.status.listening': 'Lyssnar',
    'interview.status.thinking': 'Tänker',
    'interview.question': 'Fråga {{current}} av {{total}}',
    'interview.mainQuestion': 'Huvudfråga {{current}} av {{total}}',
    'interview.recording': 'Ditt svar spelas in...',
    'interview.endInterview': 'Avsluta samtalet',
    'interview.muteTooltip': 'Stäng av mikrofon',
    'interview.unmuteTooltip': 'Slå på mikrofon',
    'interview.pauseTooltip': 'Ta en paus',
    'interview.resumeTooltip': 'Återuppta samtalet',
    'interview.subtitleTooltip.show': 'Visa undertexter (CC)',
    'interview.subtitleTooltip.hide': 'Dölj undertexter (CC)',
    'interview.toggleChat': 'Skriv istället',
    'interview.toggleVoice': 'Prata istället',
    'interview.chatTooltip.type': 'Skriv ditt svar istället',
    'interview.chatTooltip.speak': 'Prata in ditt svar istället',
    'interview.chatTooltip.unavailable': 'Tillgängligt när anslutningen är klar',
    'interview.chatDiscoveryHint': 'Kan du inte prata? Tryck för att skriva istället',
    'interview.chatPlaceholder': 'Skriv ditt meddelande...',
    'interview.sendMessage': 'Skicka',
    'interview.chat.warmHeader': 'Ta den tid du behöver, jag väntar medan du skriver',
    'interview.chat.newlineHint': 'Shift + Enter för ny rad',
    'interview.chat.aiVoiceOn': 'Röst på',
    'interview.chat.aiVoiceOff': 'Röst av',
    'interview.chat.backToVoice': 'Tillbaka till röst',
    'interview.audio.controls': 'Ljudinställningar',
    'interview.audio.callVolume': 'Samtalsvolym',
    'interview.audio.muteSpeaker': 'Stäng av högtalarljudet',
    'interview.audio.unmuteSpeaker': 'Slå på högtalarljudet',
    'interview.audio.microphone': 'Mikrofon',
    'interview.audio.speaker': 'Högtalare',
    'interview.audio.device': 'Ljudenhet',
    'interview.audio.linkedRouting': 'Telefonen styr mikrofonen och högtalaren tillsammans.',
    'interview.audio.phoneSpeaker': 'Telefonens högtalare',
    'interview.audio.phoneEarpiece': 'Telefonens hörlur',
    'interview.audio.bluetoothHeadset': 'Bluetooth-headset',
    'interview.audio.wiredHeadset': 'Headset med sladd',
    'interview.audio.usbAudio': 'USB-ljud',
    'interview.audio.systemDefault': 'Systemets standard',
    'interview.audio.changeFailed': 'Det gick inte att byta ljudenhet.',
    'interview.networkQuality.excellent': 'Nätverkskvaliteten är utmärkt.',
    'interview.networkQuality.good': 'Nätverkskvaliteten är god.',
    'interview.networkQuality.poor': 'Nätverkskvaliteten är dålig.',
    'interview.networkQuality.bad': 'Nätverkskvaliteten är mycket dålig.',
    'interview.networkQuality.offline': 'Anslutningen är offline.',
    'interview.pauseModal.title': 'Samtalet är pausat',
    'interview.pauseModal.timeRemaining': '{{time}} kvar',
    'interview.pauseModal.timeoutWarning': 'Om du stannar i pausen avslutas samtalet snart av sig självt.',
    'interview.pauseModal.resume': 'Återuppta samtalet',
    'interview.pauseModal.end': 'Avsluta samtalet',
    'interview.endConfirm.title': 'Avsluta samtalet?',
    'interview.endConfirm.body': 'Du kan inte återvända efter att du avslutat. Dina svar hittills sparas.',
    'interview.endConfirm.cancel': 'Fortsätt samtalet',
    'interview.endConfirm.end': 'Avsluta samtalet',
    'complete.checkInTitle': 'Tack för att du tog dig tid',
    'complete.checkInMessage': 'Dina svar går till teamet på {company}.',
    'studyClosed.checkInTitle': 'Det här samtalet är stängt',
    'studyClosed.checkInMessage': 'Tack för ditt intresse, det tar inte längre emot svar.',
    'studyNotOpen.checkInTitle': 'Det här samtalet är inte öppet än',
    'studyNotOpen.checkInMessage': 'Försök gärna igen senare.',
    'studyNotReady.checkInTitle': 'Samtalet är nästan klart',
    'studyNotReady.checkInMessage': 'Försök gärna igen om några minuter.',
    'participantLinkCompleted.checkInTitle': 'Du har redan haft det här samtalet',
    'participantLinkCompleted.checkInMessage': 'Tack för att du tog dig tid, du behöver inte göra något mer.',
    'loading.interview': 'Laddar samtalet...',
    'browserHelp.title': 'Öppna i din webbläsare',
    'browserHelp.description': 'Appens inbyggda webbläsare kan begränsa åtkomsten till mikrofonen. Öppna länken i {{browserOptions}} för bästa upplevelse.',
    'browserHelp.namedDescription': 'Den inbyggda webbläsaren i {{app}} kan begränsa åtkomsten till mikrofonen. Öppna länken i {{browserOptions}} för bästa upplevelse.',
    'browserHelp.appleBrowsers': 'Safari eller Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge eller Chrome',
    'browserHelp.otherBrowsers': 'Chrome eller en annan webbläsare',
    'browserHelp.openSafari': 'Öppna i Safari',
    'browserHelp.copyLink': 'Kopiera länk',
    'browserHelp.copied': 'Länken har kopierats. Klistra in den i din webbläsare.',
    'browserHelp.manualCopy': 'Det gick inte att kopiera automatiskt. Markera och kopiera länken nedan.',
    'browserHelp.copyInstructions': 'Kopiera länken nedan och klistra in den i en annan webbläsare. Du kan också leta i appens meny efter ett alternativ för att öppna sidan i din standardwebbläsare.',
    'browserHelp.linkLabel': 'Länk till samtalet',
    'browserHelp.continueAnyway': 'Fortsätt ändå',
    'preflight.microphone.recovery.denied': 'Åtkomst till mikrofonen nekades.',
    'preflight.microphone.recovery.timedOut': 'Förfrågan om mikrofonåtkomst tog för lång tid. Kontrollera om webbläsaren visar en fråga om behörighet och försök igen.',
    'preflight.microphone.recovery.notFound': 'Ingen mikrofon hittades. Anslut en mikrofon och försök igen.',
    'preflight.microphone.recovery.notReadable': 'Det gick inte att öppna mikrofonen. Stäng andra appar som använder den och försök igen.',
    'preflight.microphone.recovery.failed': 'Vi kunde inte komma åt mikrofonen. Kontrollera mikrofonen och försök igen.',
    'preflight.microphone.recovery.retry': 'Försök igen',
    'preflight.microphone.recovery.close': 'Stäng',
    'preflight.microphone.recovery.helpTitle': 'Tillåt mikrofonåtkomst',
    'preflight.microphone.recovery.helpDescription': 'Åtkomst till mikrofonen är fortfarande blockerad. Webbläsaren kan ha sparat ditt tidigare val och därför inte fråga igen.',
    'preflight.microphone.recovery.safariMacSettings': 'Välj Safari > Inställningar > Webbplatser > Mikrofon i Safaris menyrad. Leta upp den här webbplatsen i listan.',
    'preflight.microphone.recovery.chromiumSettings': 'Klicka på ikonen för webbplatsinställningar till vänster om adressfältet och välj Webbplatsinställningar > Mikrofon.',
    'preflight.microphone.recovery.siteSettings': 'Öppna webbplatsens behörigheter via ikonen eller menyn vid adressfältet, eller via webbläsarens webbplatsinställningar.',
    'preflight.microphone.recovery.allowMicrophone': 'Tillåt mikrofonåtkomst för den här webbplatsen. Gå sedan tillbaka hit och välj ”Försök igen”. Ladda om sidan om webbläsaren ber dig göra det.',
    'preflight.microphone.recovery.deviceSettings': 'Om åtkomst redan är tillåten, kontrollera att enhetens inställningar tillåter webbläsaren att använda mikrofonen.',
    'microphoneQuality.title': 'Mikrofonkvalitet',
    'microphoneQuality.instructions': 'Börja prata i några sekunder så vi kan kontrollera hur bra vi hör dig.',
    'microphoneQuality.recoveryMessage': 'Vi kan inte höra dig. Om du är i ett telefonsamtal, avsluta det först. Stäng andra appar som använder mikrofonen och försök sedan igen.',
    'microphoneQuality.poor': 'Dålig',
    'microphoneQuality.almostThere': 'Nästan där',
    'microphoneQuality.perfect': 'Perfekt!',
    'microphoneQuality.waiting': 'Väntar på ljud...',
    'microphoneQuality.from': 'Från',
    'microphoneQuality.defaultDevice': 'Standardmikrofon',
    'microphoneQuality.helpText': 'Prata högre eller flytta dig närmare mikrofonen',
    'microphoneQuality.done': 'Klar',
    'startupRecovery.title': 'Samtalet kunde inte starta',
    'startupRecovery.failed': 'Vi kunde inte ansluta till samtalstjänsten. Försök igen.',
    'startupRecovery.timedOut': 'Anslutningen tog för lång tid. Försök igen.',
    'startupRecovery.cancelled': 'Anslutningen avbröts. Du kan försöka igen när du är redo.',
    'startupRecovery.microphone': 'Vi kunde inte komma åt mikrofonen. Kontrollera behörigheterna och försök igen.',
    'startupRecovery.delayed': 'Ansluter fortfarande. Det tar längre tid än vanligt…',
    'startupRecovery.retry': 'Försök igen',
    'startupRecovery.support': 'Supportreferens',
    'startupRecovery.copy': 'Kopiera referens',
    'startupRecovery.copied': 'Kopierad',
    'startupRecovery.checking': 'Kontrollerar anslutningen…',
    'startupRecovery.unavailable': 'Kunde inte verifieras',
    'startupRecovery.advice': 'Kontrollen visar bara om tjänsterna kan nås. Du kan ändå försöka starta. Om det inte fungerar kan du prova en annan webbläsare eller ett annat nätverk.',
    'startupRecovery.checkAgain': 'Kontrollera anslutningen igen...',
    'connectionDetails.quality': 'Nätverkskvalitet',
    'connectionDetails.excellent': 'Utmärkt',
    'connectionDetails.good': 'Bra',
    'connectionDetails.poor': 'Svag',
    'connectionDetails.bad': 'Dålig',
    'connectionDetails.offline': 'Offline',
    'connectionDetails.notChecked': 'Inte kontrollerad',
    'connectionDetails.lastChecked': 'Senast kontrollerad',
    'connectionDetails.warning': 'Det gick inte att verifiera anslutningen till {{services}}.',
    'connectionDetails.navaApi': 'Clairs API',
    'connectionDetails.interviewApi': 'Clairs samtalstjänst',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Uppdatera anslutningstest',
    'connectionDetails.success': 'Anslutningskontrollen lyckades.',
    'connection.error': 'Anslutningsfel',
    'connection.errorDefault': 'Kunde inte ansluta till samtalstjänsten',
    'connection.retry': 'Försök igen',
    'versionRefresh.message': 'En ny version finns tillgänglig. Uppdatera webbläsaren när det passar dig.',
    'versionRefresh.action': 'Uppdatera',
    'cookies.banner.title': 'Vi värnar om din integritet',
    'cookies.banner.message': 'Vi använder cookies för att optimera din upplevelse, förstå produktanvändning och stödja relevant marknadsföring. Välj <bold>“Acceptera alla”</bold> för att samtycka till alla cookies, eller <bold>“Hantera inställningar”</bold> för att justera dina inställningar.',
    'cookies.banner.privacyPolicy': 'Integritetspolicy',
    'cookies.banner.acceptAll': 'Acceptera alla',
    'cookies.banner.managePreferences': 'Hantera inställningar',
    'cookies.modal.title': 'Cookie-inställningar',
    'cookies.modal.description': 'När du besöker Clair kan vi lagra eller hämta information om dig med hjälp av cookies och liknande teknik. Nödvändiga cookies håller webbplatsen fungerande. Du kan när som helst uppdatera valfria inställningar.',
    'cookies.modal.readMore': 'Läs mer i vår',
    'cookies.modal.save': 'Spara',
    'cookies.modal.close': 'Stäng cookie-inställningar',
    'cookies.modal.essential.title': 'Nödvändiga',
    'cookies.modal.essential.description': 'Krävs för webbplatsens grundläggande funktionalitet. Nödvändiga cookies kan inte inaktiveras.',
    'cookies.modal.analytics.title': 'Analys',
    'cookies.modal.analytics.description': 'Hjälper Clair att förstå hur webbplatsen fungerar, hur besökare interagerar med den och om det kan finnas tekniska problem.',
    'invitation.subject': 'Ett kort samtal med {company}',
    'invitation.greeting': 'Hej {name},',
    'invitation.body': 'Vi vill gärna höra hur det går för dig.',
    'invitation.aiNotice': 'Du pratar med Clair, vår AI-assistent. De flesta tycker att det är lättare att vara ärlig mot en AI än mot en person, och du kan göra det när det passar dig, på jobbet eller hemma.',
    'invitation.button': 'Starta samtalet',
    'invitation.fallbackLink': 'Eller klistra in den här länken i webbläsaren:',
    'invitation.footer': 'Du får det här mejlet för att du är kund hos {company}. Samtalet hålls av Clair, en AI-assistent, på deras uppdrag.',
    'invitation.optOut': 'Skicka inte det här till mig igen',
    'sms.invite': '{company} bjuder in dig till ett kort samtal:',
    'sms.stop': 'Avsluta SMS:',
};
//# sourceMappingURL=sv.js.map